export default "__VITE_ASSET__DII1Nqo0__"